import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import { useSelector } from "react-redux";
import { withRouter, useHistory, Redirect, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";

import AuthWrapper from "./AuthWrapper";
import { METATAGS } from "../../constants";
import { TextInput } from "components/Input";
import { CustomButton } from "components/CustomButton";
import { APP_ROUTES, getRoute } from "helpers/routeHelpers";
import { ResetPassword } from "api/api.service";
import { SuccessModalCustom } from "components/SuccessModalCustom";
import loginImage from "assets/images/aiAPaiT/login/login-img.png";
import passIcon from "assets/images/aiAPaiT/lock-icon.png";

const ResetPasswordView = (props) => {
    let {} = props;

    const history = useHistory();
    const { state } = useLocation();
    const [resetSuccessModal, setResetSuccessModal] = useState(false);
    const [passwordFieldType, setPasswordFieldType] = useState(false);
    let isAuthenticated = useSelector((state) => state.userAuth.isAuthenticated);

    const [isLoading, setIsLoading] = useState(false);

    const modalCloseHandler = () => {
        setResetSuccessModal(false);
        history.push(APP_ROUTES.LOGIN);
    };

    const passwordFieldChangeHandler = () => {
        setPasswordFieldType(!passwordFieldType);
    };

    const formik = useFormik({
        initialValues: {
            newPassword: "",
            confirmPassword: ""
        },
        validationSchema: Yup.object({
            newPassword: Yup.string().required("Enter New Password"),
            confirmPassword: Yup.string().when("newPassword", {
                is: (val) => (val && val.length > 0 ? true : false),
                then: Yup.string().oneOf(
                    [Yup.ref("newPassword")],
                    "Please make sure your passwords match"
                )
            })
        }),

        onSubmit: (values) => {
            handleSubmit(values);
        }
    });

    const handleSubmit = async (values) => {
        let { confirmPassword } = values;
        try {
            setIsLoading(true);
            let body = {
                token: state?.tokenId,
                password: confirmPassword
            };
            let res = await ResetPassword(body);
            toast.success("Password has been reset successfully !");
            history.push(getRoute(APP_ROUTES?.LOGIN));
        } finally {
            setIsLoading(false);
        }
    };

    if (isAuthenticated) {
        return <Redirect to={APP_ROUTES.DASHBOARD} />;
    }

    return (
        <>
            <MetaTags>
                <title>{METATAGS.RESET_PASSWORD}</title>
            </MetaTags>
            <AuthWrapper
                leftContent={
                    <div className="text-center">
                        <h1 className="text-white fw-normal">
                            <span>PASSWORD RESET</span>
                        </h1>
                    </div>
                }
                data={
                    <div className="bv-forget-wrap margin-top-vh">
                        <p className="login-type ms-0">Reset Password</p>
                        <form className="mt-3" onSubmit={formik.handleSubmit}>
                            <div className="mb-4">
                                <TextInput
                                    placeholder="Enter New Password"
                                    type={!passwordFieldType ? "password" : "text"}
                                    name="newPassword"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.newPassword}
                                    iconFile={passIcon}
                                    appendIcon={true}
                                    iconClickHandler={passwordFieldChangeHandler}
                                />
                                {formik.touched.newPassword && formik.errors.newPassword ? (
                                    <span className="error">{formik.errors.newPassword}</span>
                                ) : null}
                            </div>
                            <div className="mb-5">
                                <TextInput
                                    placeholder="Re-enter New Password"
                                    type={!passwordFieldType ? "password" : "text"}
                                    name="confirmPassword"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.confirmPassword}
                                    iconFile={passIcon}
                                    appendIcon={true}
                                    iconClickHandler={passwordFieldChangeHandler}
                                />
                                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                    <span className="error">{formik.errors.confirmPassword}</span>
                                ) : null}
                            </div>

                            <CustomButton
                                loading={isLoading}
                                color="primary"
                                title="Reset Password"
                                className="w-100 ms-0"
                            />
                        </form>
                    </div>
                }
                leftImgUrl={loginImage}
            />
            <SuccessModalCustom
                btnTitle="Go to Login"
                mainContent="Password han been reset successfully "
                modalActivator={resetSuccessModal}
                modalCloseHandler={modalCloseHandler}
            />
        </>
    );
};

export default withRouter(ResetPasswordView);
